module.exports = __webpack_public_path__ + "static/media/milex-pessaries-product@2x.9880bcc9.jpg";